import { AsyncThunk } from "@reduxjs/toolkit";
import dayjs from "dayjs";

import { useModal } from "../../hooks/useModal";
import { PaymentStatusChangeModal } from "../PaymentStatusChangeModal";
import { ToggleButtons } from "../ToggleButtons";

interface PaymentStatusButtonProps<TPayload> {
  isPaid: boolean;
  paidAt?: string | null;
  thunk: AsyncThunk<any, TPayload, any>;
  payload: TPayload;
  translationKey: string;
  isTableCell?: boolean;
  isUpdating?: (state: any) => boolean;
  isDisabled?: boolean;
}

export const PaymentStatusButton = <TPayload,>({
  isPaid,
  paidAt,
  thunk,
  payload,
  translationKey,
  isTableCell = false,
  isUpdating,
  isDisabled = false,
}: PaymentStatusButtonProps<TPayload>) => {
  const { isModalVisible, toggleModalVisibility } = useModal();
  const paidAtFormatted = paidAt ? dayjs(paidAt).format("DD.MM.YYYY") : undefined;

  const handleWrapperClick = (e: React.MouseEvent) => {
    if (isTableCell) e.stopPropagation();
  };

  const handleToggleChange = (nextValue: boolean) => {
    if (nextValue === isPaid) return;
    toggleModalVisibility();
  };

  return (
    <div onClick={handleWrapperClick}>
      <ToggleButtons
        value={isPaid}
        trueExtraText={paidAtFormatted}
        onChange={handleToggleChange}
        isDisabled={isDisabled}
      />

      <PaymentStatusChangeModal
        isPaid={isPaid}
        thunk={thunk}
        payload={payload}
        translationKey={translationKey}
        isModalVisible={isModalVisible}
        toggleModalVisibility={toggleModalVisibility}
        isUpdating={isUpdating}
      />
    </div>
  );
};
